import { render, staticRenderFns } from "./TgTgsTitle.vue?vue&type=template&id=79a98800&"
import script from "./TgTgsTitle.vue?vue&type=script&lang=js&"
export * from "./TgTgsTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports